export const apiURI = process.env.REACT_APP_API_URI || " ";
export const webURI = process.env.REACT_APP_WEB_URI || " ";
export const msClientID = process.env.REACT_APP_MS_CLIENT_ID || " ";
export const msAuthority = process.env.REACT_APP_MS_AUTHORITY || " ";
// Blob access (images + historical PDFs) no longer goes through the browser. The backend
// streams blobs via Managed Identity through the authenticated proxy endpoints
// GET /form/image and GET /form/pdf (see ViewImage and useHistoricalPDFLink), so the
// storage account needs no public access, SAS, or CORS — hence no blob URL / token here.
export const subscriptionKey =
  process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY || "";
// userManualURL removed — the manual is now stored in the qualityreports container and
// served via the authenticated backend proxy (see openUserManual.function.js).
// bulkUploadTemplateURL removed — the Excel template is now stored in the qualityreports
// container and downloaded via the authenticated backend proxy GET /form/file (see
// downloadBulkUploadTemplate.function.js).
